<div class="collectionView">
  <div *ngIf="!sortedAlbums" class="loadingContainer">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div *ngIf="sortedAlbums">
    <div class="albumHeadingAndControlsContainer">
      <h2>Albums <small class="text-muted" data-ta-name="albumCount">({{sortedAlbums.length}})</small></h2>
      <div class="albumViewControls">
        <div class="searchControls">
          <div class="input-group">
            <input type="search" class="form-control" placeholder="Search for album" data-ta-name="albumSearchInput"
                   name="search-term" id="search-term" [(ngModel)]="searchText" (ngModelChange)="searchTextChanged($event)"/>
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
        <div class="dropdown" dropdown>
          <button type="button" class="btn btn-light dropdown-toggle" data-ta-name="albumSortButton" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" dropdownToggle>
            Sort By
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" (click)="sortAlphabeticallyByArtistNameThenChronologically()" href="javascript:void(0)" data-ta-name="sortAlphabeticallyByArtistNameThenChronologically">
              <i class="fa fa-fw fa-check" *ngIf="albumSortViewIsAlphabeticalByArtistNameThenChronological()"></i>
              <i class="fa fa-fw" *ngIf="!albumSortViewIsAlphabeticalByArtistNameThenChronological()"></i>
              Artist name
            </a>
            <a class="dropdown-item" (click)="sortByArtistAlbumCountThenChronologically()" href="javascript:void(0)" data-ta-name="sortByArtistAlbumCountThenChronologically">
              <i class="fa fa-fw fa-check" *ngIf="albumSortViewIsArtistAlbumCountThenChronological()"></i>
              <i class="fa fa-fw" *ngIf="!albumSortViewIsArtistAlbumCountThenChronological()"></i>
              Artist album count (desc)
            </a>
            <a class="dropdown-item" (click)="sortByReviewDate()" href="javascript:void(0)" data-ta-name="sortByReviewDate">
              <i class="fa fa-fw fa-check" *ngIf="albumSortViewIsReviewDate()"></i>
              <i class="fa fa-fw" *ngIf="!albumSortViewIsReviewDate()"></i>
              Album review date (desc)
            </a>
            <a class="dropdown-item" (click)="sortByRatingAscending()" href="javascript:void(0)" data-ta-name="sortByRatingAscending">
              <i class="fa fa-fw fa-check" *ngIf="albumSortViewIsRatingAscending()"></i>
              <i class="fa fa-fw" *ngIf="!albumSortViewIsRatingAscending()"></i>
              Album rating
            </a>
            <a class="dropdown-item" (click)="sortByRatingDescending()" href="javascript:void(0)" data-ta-name="sortByRatingDescending">
              <i class="fa fa-fw fa-check" *ngIf="albumSortViewIsRatingDescending()"></i>
              <i class="fa fa-fw" *ngIf="!albumSortViewIsRatingDescending()"></i>
              Album rating (desc)
            </a>
            <a class="dropdown-item" (click)="sortByYearAscending()" href="javascript:void(0)" data-ta-name="sortByYearAscending">
              <i class="fa fa-fw fa-check" *ngIf="albumSortViewIsYearAscending()"></i>
              <i class="fa fa-fw" *ngIf="!albumSortViewIsYearAscending()"></i>
              Album release year
            </a>
            <a class="dropdown-item" (click)="sortByYearDescending()" href="javascript:void(0)" data-ta-name="sortByYearDescending">
              <i class="fa fa-fw fa-check" *ngIf="albumSortViewIsYearDescending()"></i>
              <i class="fa fa-fw" *ngIf="!albumSortViewIsYearDescending()"></i>
              Album release year (desc)
            </a>            
          </div>
        </div>
      </div>
    </div>

    <div class="card-group">
      <div *ngFor="let album of sortedAlbums | filterByAlbum : searchTextForFiltering">
        <app-album-card-with-artist [album]="album"></app-album-card-with-artist>
      </div>
    </div>
  </div>
</div>
